import { selectGlobalBannerHeight } from "@/context/modules/app";
import useAppStore from "@/context/store";
import { useSideNavWidth } from "@/context/useSideNavWidth";
import useSideNavCollapse from "@/utils/useSideNavCollapse";
import classNames from "classnames";
import React from "react";
import styles from "./index.module.less";

interface LayoutProps {
  header?: React.ReactNode;
  sideNav?: React.ReactNode;
  topBar?: React.ReactNode;
  children?: React.ReactNode;
  sideNavVisible?: boolean;
  extendContentToHeader?: boolean;
}

const Layout: React.FC<LayoutProps> = ({
  header,
  sideNav,
  topBar,
  children,
  sideNavVisible = true,
  extendContentToHeader = false,
}) => {
  const globalBannerHeight = useAppStore(selectGlobalBannerHeight);
  const columnSize = useAppStore((s) => s.columnSize);
  const totalHeaderHeight = globalBannerHeight + 80;

  const [isCollapsed] = useSideNavCollapse();
  const wrapperWidth = useAppStore((s) => s.wrapperWidth);

  // 计算侧边导航宽度
  const sideNavWidth = useSideNavWidth();

  return (
    <div
      className={classNames(styles.layout, {
        [styles.noSideNav]: !sideNavVisible,
        [styles.extendContentToHeader]: extendContentToHeader,
        "side-hide": !sideNavVisible,
        "side-collapsed": sideNavVisible && isCollapsed,
      })}
      style={
        {
          "--total-header-height": `${totalHeaderHeight}px`,
          "--global-banner-height": `${globalBannerHeight}px`,
          "--side-nav-width": `${sideNavWidth}px`,
          "--wrapper-width": `${wrapperWidth}px`,
          "--column-size": `${columnSize}px`,
        } as React.CSSProperties
      }
    >
      {topBar && <div className={styles.topBar}>{topBar}</div>}
      {sideNavVisible && sideNav && (
        <div className={styles.sideNav}>{sideNav}</div>
      )}
      {header && (
        <div id="layout-header" className={styles.header}>
          {header}
        </div>
      )}
      <div
        id="layout-content"
        className={classNames(styles.content, "page-content", {
          [styles.extendContentToHeader]: extendContentToHeader,
        })}
      >
        {children}
      </div>
    </div>
  );
};

export default Layout;
